export const INVALID_FILE_FORMAT_ERROR_TEXT =
  'Invalid file format. Please upload a supported file type.';

export const INVALID_FILE_FORMAT_TOAST = {
  title: 'Invalid File Format',
  text: 'Please upload a supported file format for this tool.',
} as const;

export const isInvalidFileFormatError = (error: string) =>
  error === INVALID_FILE_FORMAT_ERROR_TEXT;
